import { styled } from '@mui/material/styles';

const PREFIX = 'TopBar';

const classes = {
    rightMenuButton: `${PREFIX}-rightMenuButton`,
    centered: `${PREFIX}-centered`,
    toolbarMargin: `${PREFIX}-toolbarMargin`,
    appBar: `${PREFIX}-appBar`,
    rightItems: `${PREFIX}-rightItems`
};

export default styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.rightMenuButton}`]: {
        marginLeft: theme.spacing(1),
    },

    [`& .${classes.centered}`]: {
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)"
    },

    [`& .${classes.toolbarMargin}`]: {
        ...theme.mixins.toolbar,
        marginBottom: '0',
    },

    [`& .${classes.appBar}`]: {
        backgroundColor: theme.palette.mode === 'light' ? '#FFF' : '#292929',
        color: theme.palette.primary.main,
        boxShadow:"none",
        paddingTop: `env(safe-area-inset-top)`,
        paddingLeft: `env(safe-area-inset-left)`,
        paddingRight: `env(safe-area-inset-right)`,
        zIndex: 65535
    },

    [`& .${classes.rightItems}`]: {
        flex: '0 1 auto',
        marginLeft: 'auto'
    }
}));

export { classes };